import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { SharePageService } from '@/services/share-page/share-page-service';
import type { SpecificationFeatureControlService } from '../specification-feature-control-service';


@injectable()
export class SpecificationFeatureControlServiceImpl implements SpecificationFeatureControlService {
    constructor(
        @inject(SharePageService)
        private readonly _sharePageService: SharePageService,
    ) { }

    get isShareMode() {
        return !!this._sharePageService.isSharePage;
    }

    get isOptimizationEnabled(){
        return !this._sharePageService.isSharePage;
    }

    get isContentAdjustmentEnabled(){
        return !this._sharePageService.isSharePage;
    }

    get isCreateNewTaskEnabled(){
        return !this._sharePageService.isSharePage;
    }

    get isExportEnabled(){
        return !this._sharePageService.isSharePage;
    }

    get isEditEnabled(){
        return !this._sharePageService.isSharePage;
    }
}
